module.exports = __webpack_public_path__ + "img/17.b5582bb4.png";